import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';

@Component({
  selector: 'data-filter-chips',
  templateUrl: './data-filter-chips.component.html',
  styleUrls: ['./data-filter-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DataFilterChipsComponent {
  @Input() public filters: any;

  @Output() public onFilterSelection = new EventEmitter<any>();

  public onChipSelectionChange(filter: any, event: MatChipSelectionChange): void {
    if (event.isUserInput) {
      this.onFilterSelection.emit(filter);
    }
  }
}
